import axios from 'axios';
import { toast } from 'react-toastify';
import { unifiedBaseURL } from './api';


const apiVersion = 'v2';
class PortConfigTemplate {
  baseURL = process.env.REACT_APP_BASE_URL + `/api/v2/portConfig`;
  static headers = {}
  constructor(api) {
    // console.log({ api })
    this.api = api
    this.headers = { Authorization: `Bearer ${api.token}`, };
  }


  async getPortConfigTemplates(dc, portType, ataType,compID) {
    console.log("this.headers", portType)

    const { data } = await axios.get(
      `${unifiedBaseURL(dc)}${apiVersion}/portConfig/getPortConfigTemplate?compID=${compID}`,
      { headers: this.headers, params: { portType, ataType } },
    );
    return data;
  }

  async getPortConfigTemplateByPortType(dc, portType,ataType) {
    console.log("this.headers", portType)

    const { data } = await axios.get(
      `${unifiedBaseURL(dc)}${apiVersion}/portConfig/getPortConfigTemplate/${portType}?ataType=${ataType}`,
      { headers: this.headers, },
    );
    return data;
  }
  async addPortConfigTemplate(body, compID, dc) {
    const { data } = await axios.post(
      `${unifiedBaseURL(dc)}${apiVersion}/portConfig/addPortConfigTemplate/${compID}`,
      body,
      { headers: this.headers },
    );
    return data;
  }
  async getAllCustomTemplates(page = 1, limit = 10) {
    const { data } = await axios.get(
      `${unifiedBaseURL('la')}${apiVersion}/portConfig/getAllCustomTemplates`,
      {
        headers: this.headers,
        params: {
          page,
          limit,
        },
      }
    );
    return data;
  }
  async deleteCustomTemplate(id) {
    const { data } = await axios.delete(
      `${unifiedBaseURL('la')}${apiVersion}/portConfig/deleteCustomTemplate/${id}`,
      { headers: this.headers }
    );
    return data;
  }
  async updateCustomTemplate(id, body) {
    const { data } = await axios.put(
      `${unifiedBaseURL('la')}${apiVersion}/portConfig/updateCustomTemplate/${id}`,
      body,
      { headers: this.headers }
    );
    return data;
  }
};

export default PortConfigTemplate;
